import type { IconName } from "../../icons";
import type { NavGroup, NavItem } from "./navTypes";

/** Which module groups are open, by group id; a group never toggled is open. */
export type OpenGroups = Record<string, boolean>;

export const FALLBACK_MODULE_ICON: IconName = "grid";

export function isModule(group: NavGroup): boolean {
  return Boolean(group.icon);
}

export function isActiveItem(item: NavItem, active: string | undefined): boolean {
  return item.id === active;
}

export function containsActive(group: NavGroup, active: string | undefined): boolean {
  return group.items.some((item) => isActiveItem(item, active));
}

/** The module that holds the current page, if any. */
export function activeModuleId(nav: NavGroup[], active: string | undefined): string | undefined {
  return nav.find((group) => isModule(group) && containsActive(group, active))?.id;
}

export function isGroupOpen(openGroups: OpenGroups, groupId: string): boolean {
  return openGroups[groupId] ?? true;
}

/** Only a group the person closed needs reopening; the rest are already open. */
export function needsReopening(openGroups: OpenGroups, groupId: string | undefined): groupId is string {
  return groupId !== undefined && openGroups[groupId] === false;
}

export function withGroupOpen(openGroups: OpenGroups, groupId: string, open: boolean): OpenGroups {
  return { ...openGroups, [groupId]: open };
}

export function moduleListId(group: NavGroup): string {
  return `nb-side-${group.id}`;
}
